<template>
    <div class="well-status-overlay" :class="$uiUtils.getStatusColor(well.status)"></div>
</template>

<script>
export default {
    name: 'WellStatusOverlay',
    props: {
        well: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.well-status-overlay {
    width: 100%;
    height: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    transform-origin: 0 0;
    mix-blend-mode: overlay;
    border-radius: $border-radius;
    pointer-events: none;

    &.red {
        background-color: $status-discarded;
    }
    &.blue {
        background-color: $status-frozen;
    }
    &.green {
        background-color: $status-transferred;
    }
    &.yellow {
      background-color: $status-pending;
    }
    &.purple {
        background-color: $status-thawed;
    }
    &.gray {
        background-color: $dark;
    }
}
</style>
